// extracted by mini-css-extract-plugin
module.exports = {"chevron":"Chevron_chevron__SGkh3","open":"Chevron_open__bu_4T","closed":"Chevron_closed__XjKJn"};